export class DialogModelConfirmDeleteMed {
    constructor(
      public order: any
    ) {}
  }
  